//import createCachedSelector from 're-reselect';
//import { createSelector } from 'reselect';
//import * as recordStore from '../recordStore';

const selectFifoAlert = state => state.alertStore.alertQueue[0];

export const selectors = {
    selectFifoAlert
}